import { Box, Typography, useMediaQuery } from "@mui/material";
import React, { useState, useEffect } from "react";
import Header from "../../Components/Common/Header";
import { colors } from "../../theme/theme";
import HomePageSearchBar from "../../Components/Common/HomePageSearchBar";
import ProductCards from "../../Components/Home/ProductCards";
import Footer from "../../Components/Common/Footer";
import BrandLogoSlider from "../../Components/Home/BrandLogoSlider";
import { useDispatch, useSelector } from "react-redux";
import {
  collectionsQuery,
  fetchCollections,
} from "../../redux/slices/collectionsSlice";
import QueryCards from "../../Components/Home/QueryCards";
import HowItWorks from "../../Components/Home/HowItWorks";

const HomePage = () => {
  const dispatch = useDispatch();

  const { collections } = useSelector((state) => state.collections);

  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(fetchCollections());
  }, []);

  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        background: "#FFFFFF",
        minHeight: "100vh",
      }}
    >
      <Header />

      <HomePageSearchBar search={search} setSearch={setSearch} />

      <QueryCards />

      <BrandLogoSlider />

      <Box
        sx={{
          maxWidth: "1200px",
          mx: "auto",
          px: smallScreen ? 2 : 3,
          pb: 4,
        }}
      >
        {collections &&
          collections?.map((collection, index) => {
            const collectionHeading = collectionsQuery.find(
              (item) => item.query === collection?.query,
            )?.heading;
            return (
              <Box
                key={index}
                sx={{
                  mb: smallScreen ? 3 : 3.5,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Poppins-Bold",
                    fontSize: smallScreen ? "18px" : "22px",
                    fontWeight: 700,
                    color: "#1a1a1a",
                    mb: smallScreen ? 1.2 : 1.5,
                    textTransform: "capitalize",
                    letterSpacing: "-0.015em",
                  }}
                >
                  {collectionHeading}
                </Typography>

                <ProductCards productData={collection.products || []} />
              </Box>
            );
          })}
      </Box>

      <Footer />
    </Box>
  );
};

export default HomePage;
